import { useEffect, useRef, React } from "react";
import { useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";
import gsap from "gsap";

export const About = () => {
  const navigate = useNavigate();
  const textRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ delay: 0.2 });
    tl.fromTo(
      textRef.current,
      { x: 0, opacity: 1 },
      { x: 150, duration: 1.2, ease: "power2.out" }
    ).to(textRef.current, { x: 0, duration: 1.2, ease: "power2.inOut" });
  }, []);

  const goToHome = () => {
    navigate("/");
  };

  const goToWork = () => {
    navigate("/work");
  };

  return (
    <div className="flex flex-col w-full min-h-screen px-4 md:px-16 lg:px-32 py-10 font-rubik max-w-7xl mx-auto">
      <div className="flex flex-col w-full mb-10">
        <div className="flex justify-between items-center">
          <div
            className="text-blue text-lg sm:text-xl md:text-2xl font-medium cursor-pointer"
            onClick={goToHome}
          >
            Vishal
          </div>
          <div
            className="bg-gradient-to-tr from-peach to-peachLite text-transparent bg-clip-text text-base sm:text-lg md:text-xl font-medium cursor-pointer"
            onClick={goToWork}
          >
            Work
          </div>
        </div>
      </div>

      <div className="flex flex-col w-full">
        <div className="flex flex-col w-full mb-10">
          <div className="w-full h-[10%] bg-gradient-to-tr from-peach to-peachLite bg-clip-text text-transparent text-4xl font-medium">
            About Me
          </div>
          <div className="flex flex-col font-normal text-blue text-base leading-loose sm:text-lg md:text-xl max-w-3xl sm:max-w-4xl md:max-w-5xl md:leading-loose">
            <p ref={textRef} className="mb-6">
              Hi, I'm Vishal! 👋
            </p>
            <p className="mb-6">
              I'm a Software Developer with 3 years of experience creating
              full-stack applications that solve real-world problems. I focus on
              building scalable backend systems using technologies like NestJS
              and MongoDB, and crafting interactive frontends with React and
              modern web frameworks. My experience includes integrating AI
              capabilities such as voice and object recognition, developing
              accessibility tools for visually impaired users, and building
              educational platforms like{" "}
              <a
                href="https://port11.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-1"
              >
                Port11
              </a>{" "}
              and{" "}
              <a
                href="https://plode.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-1"
              >
                Plode
              </a>
              .
            </p>
            <p className="mb-6">
              I'm passionate about building software and equally driven to
              understand the systems that power it—from how operating systems
              manage processes and memory to how data is structured and flows
              through different layers of technology. I'm especially intrigued
              by how machine learning models are trained and deployed, and how
              large language models and multi-agent systems are transforming the
              way we build intelligent software.
            </p>{" "}
          </div>
        </div>
      </div>

      <div className="flex flex-col w-full mb-10 mt-2">
        <div className="w-full h-[10%] bg-gradient-to-tr from-peach to-peachLite bg-clip-text text-transparent text-4xl font-medium mb-8">
          Education
        </div>
        <div className="flex flex-col font-normal text-blue text-base leading-loose sm:text-lg md:text-xl max-w-3xl sm:max-w-4xl md:max-w-5xl md:leading-loose">
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-2 text-peach">
              University of Michigan - Dearborn
            </h3>
            <p className="text-lg font-medium mb-1 text-blue">
              Master's in Computer and Information Science
            </p>
            <p className="text-base text-blue mb-2">2024 - 2026</p>
            <p className="text-sm text-liteBlue">
              Coursework: Algorithm Analysis and Design, Advanced Operating
              Systems, Text Mining and Information Retrieval, Cloud Computing.
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-2 text-peach">
              K S Institute of Technology
            </h3>
            <p className="text-lg font-medium mb-1 text-blue">
              Bachelor's in Computer Science and Engineering
            </p>
            <p className="text-base text-blue mb-2">2017 - 2021</p>
            <p className="text-sm text-liteBlue">
              Coursework: Data Structures, Big Data, Machine Learning,
              Artificial Intelligence, Computer Networks, Computer Organization.
            </p>
          </div>
        </div>
      </div>

      <div className="flex-grow"></div>

      <div className="flex flex-row items-end justify-center text-base sm:text-lg text-blue gap-4 w-full">
        <Footer />
      </div>
    </div>
  );
};
